import { PLATFORM } from 'aurelia-framework';
import { roles } from 'routes';

export const statistics_dashboard_routes = [
  {
    route: ['statistics-dashboard-view'],
    name: 'statistics-dashboard-view',
    settings: { roles: [roles.sales, roles.administrator], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('components/statistics-dashboard/nets/statistics-dashboard-view') },
      side: { moduleId: null },
    },
    nav: true,
    title: 'general.dashboard',
    route_base: 'statistics',
    section: 'statistics',
    roles: [roles.sales, roles.administrator],
  },
];
